import {dedupingMixin} from '@polymer/polymer/lib/utils/mixin';
import {isNotQualified} from '@aoflmkt/is-webp-qualified';

/**
 * Mixin function for IsWebpQualifiedMixin class
 */
const isWebpQualifiedMixin = dedupingMixin(((superClass) => {
  /**
   * @class IsWebpQualifiedMixin
   * @extends superClass
   */
  class IsWebpQualifiedMixin extends superClass {
    /**
     * Creates an instance of IsWebpQualifiedMixin.
     * @memberof IsWebpQualifiedMixin
     */
    constructor(...args) {
      super(...args);

      if (!isNotQualified) {
        this.classList.add('is-webp-qualified');
      }
    }
  }
  return IsWebpQualifiedMixin;
}));

export default isWebpQualifiedMixin;
